import { Minus, Plus } from '@/components/ui/icons';
import { IconButton } from '@/components/ui/IconButton';
import { quantityStepperStyles } from './QuantityStepper.styles';

export type QuantityStepperProps = {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  decreaseLabel: string;
  increaseLabel: string;
  className?: string;
};

export function QuantityStepper({
  value,
  onChange,
  min = 1,
  max,
  disabled = false,
  decreaseLabel,
  increaseLabel,
  className,
}: QuantityStepperProps): JSX.Element {
  const atMin = value <= min;
  const atMax = max != null && value >= max;

  return (
    <div className={`${quantityStepperStyles.root}${className ? ` ${className}` : ''}`}>
      <IconButton
        type="button"
        size="sm"
        variant="outline"
        aria-label={decreaseLabel}
        disabled={disabled || atMin}
        onClick={() => onChange(Math.max(min, value - 1))}
      >
        <Minus className="h-4 w-4" aria-hidden />
      </IconButton>
      <span className={quantityStepperStyles.value} aria-live="polite">
        {value}
      </span>
      <IconButton
        type="button"
        size="sm"
        variant="outline"
        aria-label={increaseLabel}
        disabled={disabled || atMax}
        onClick={() => onChange(max != null ? Math.min(max, value + 1) : value + 1)}
      >
        <Plus className="h-4 w-4" aria-hidden />
      </IconButton>
    </div>
  );
}
